<template>
  <transition name="surveys">
    <div>
      <div class="survey-backdrop"></div>
      <div class="survey" v-if="!completed">
        <img v-if="logo" :src="logo" />
        <div class="survey__controls" v-if="!started">
          <div class="survey__controls__header">
            <h3 class="header--highlighted" v-text="survey.title"></h3>
            <p v-text="survey.description"></p>
          </div>
          <div class="survey__controls__actions">
            <button @click="$emit('cancel')" class="mdl-button mdl-js-button mdl-button--raised primary-bg mr--2">Cancel</button>
            <button @click="startSurvey" class="mdl-button mdl-js-button mdl-button--raised primary-bg" v-text="update ? 'Continue' : 'Start'"></button>
          </div>
        </div>
        <div class="survey__survey" v-else>
          <div class="survey__survey__header">
            <h3 class="header--highlighted" v-text="survey.title"></h3>
            <p v-text="survey.description"></p>
            <p class="text--error" v-if="error">Question <b v-text="error"></b> is required.</p>
          </div>
          <div class="survey__survey__content">
            <div
              v-for="(field, key) in response[page]"
              :key="key"
              class="mt--4"
              :class="{ 'select-margin' : field.type === 'select' && (key + 1 === response[page].length)}"
            >
              <field :field="field" />
            </div>
          </div>
          <div class="survey__survey__actions">
            <button v-if="page > 0" @click="page--" class="mdl-button mdl-js-button mdl-button--raised primary-bg btn--icon">
              <span class="material-icons">navigate_before</span>
            </button>
            <button @click="saveSurvey" :class="(response.length > page + 1) ? 'mr--auto' : 'mr--2'" class="mdl-button mdl-js-button mdl-button--raised primary-bg ml--auto">Save & Close</button>
            <button v-if="response.length === page + 1" @click="submitSurvey" class="mdl-button mdl-js-button mdl-button--raised primary-bg mr--auto">Submit</button>
            <button v-if="response.length > page + 1" @click="nextPage" class="mdl-button mdl-js-button mdl-button--raised primary-bg btn--icon">
              <span class="material-icons">navigate_next</span>
            </button>
          </div>
        </div>
      </div>
      <div class="survey" v-else>
        <img v-if="logo" :src="logo" />
        <div class="survey__controls">
          <div class="survey__controls__header">
            <h4 v-text="`Thank you for completing ${survey.title} survey.`"></h4>
            <button @click="$emit('complete')" class="mdl-button mdl-js-button mdl-button--raised primary-bg">Close</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Field from './Field'

  export default {
    name: 'surveys-modal',
    components: { Field },
    props: {
      survey: {
        type: Object,
        required: true
      },
      logo: {
        type: String,
        required: false
      }
    },
    data: () => ({
      show: false,
      response: [],
      page: 0,
      started: false,
      timer: 0,
      completed: false,
      error: null,
      busy: false
    }),
    watch: {
      survey: {
        immediate: true,
        handler (survey) {
          let fields = survey.response ? JSON.parse(survey.response) : JSON.parse(survey.fields)
          let page = 0
          let arr = []
          let tempArr = []

          for (let i = 0; i < fields.length; i++) {
            if (fields[i].type === 'pagebreak') {
              arr[page] = tempArr
              tempArr = []
              page++
              continue
            }
            tempArr.push(fields[i])
          }

          arr[page] = tempArr
          this.response = arr
       }
      }
    },
    computed: {
      update () {
        return this.survey.id ? true : false
      }
    },
    methods: {
      startSurvey () {
        this.started = true
        setInterval(() => {
          if (!this.started) return
          this.timer += 1
        }, 1000)
      },
      saveSurvey () {
        if (this.busy) return
        this.busy = true
        // Add page breaks back
        if (Array.isArray(this.response[0])) {
          for (let i = 0; i < (this.response.length - 1); i++) {
            this.response[i].push({
              id: Math.floor(Math.random() * Math.floor(1000000000)),
              name: 'Page Break',
              type: 'pagebreak',
              description: 'Splits survey into multiple pages',
              icon: 'import_contacts',
              skip: true,
              value: ''
            })
          }
        }
        
        let response = [].concat.apply([], this.response)
        if (this.update) {
          window.axios.patch(`https://eymbhklhck.execute-api.eu-west-2.amazonaws.com/production/survey-responses/${this.survey.id}`, {
            response: JSON.stringify(response),
            time_taken: this.survey.time_taken + this.timer
          }).then(() => {
            this.$emit('cancel')
          })
        } else {
          let payload = {
            survey_id: this.survey.s_id,
            user_id: this.$store.getters.user.id,
            client_id: this.$store.getters.user.client_id,
            response: JSON.stringify(response),
            completed: 0,
            time_taken: this.timer
          }
          window.axios.post(`https://eymbhklhck.execute-api.eu-west-2.amazonaws.com/production/survey-responses`, payload)
            .then(() => {
              this.$emit('cancel')
            })
        }
      },
      nextPage () {
        for (let i = 0; i < this.response[this.page].length; i++) {
          let field = this.response[this.page][i]
          if (field.required && (!field.value || (field.type === 'select' && field.multiple && !field.value.length)) || (field.type === 'checkbox' && !field.value.length)) {
            field.error = true
            this.error = field.label
            return
          } else {
            field.error = false
          }
        }

        this.error = false
        this.page++
      },
      submitSurvey () {
        if (this.busy) return
        this.busy = true
        
        let response = [].concat.apply([], this.response)
        for (let i = 0; i < response.length; i++) {
          let field = response[i]
          if (field.required && (!field.value || (field.type === 'select' && field.multiple && !field.value.length)) || (field.type === 'checkbox' && !field.value.length)) {
            field.error = true
            this.error = field.label
            return
          } else [
            field.error = false
          ]
        }

        if (this.update) {
          window.axios.patch(`https://eymbhklhck.execute-api.eu-west-2.amazonaws.com/production/survey-responses/${this.survey.id}`, {
            response: JSON.stringify(response),
            time_taken: this.survey.time_taken + this.timer,
            completed: 1,
            completion_date: new Date()
          }).then(() => {
            this.completed = true
          })
        } else {
          let payload = {
            survey_id: this.survey.s_id,
            user_id: this.$store.getters.user.id,
            client_id: this.$store.getters.user.client_id,
            response: JSON.stringify(response),
            completed: 1,
            time_taken: this.timer,
            completion_date: new Date()
          }
          window.axios.post(`https://eymbhklhck.execute-api.eu-west-2.amazonaws.com/production/survey-responses`, payload)
            .then(() => {
              this.completed = true
            })
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

  @import '../scss/variables';
  @import '../scss/bp';

  .survey-backdrop {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba($black, 0.7);
    z-index: 1000;
  }

  .survey {
    position: absolute;
    left: 50%;
    top: 5%;
    transform: translate(-50%, -5%,);
    z-index: 1001;
    background: $white;
    padding: 20px;
    box-shadow: 0 0 10px -3px rgba($black, .4);
    border-radius: 5px;
    min-width: 90%;
    margin: 20px 0;
    max-height: 95%;
    overflow-y: auto;

    @include bp(min-width, 768px) {
      min-width: unset;
      width: 600px;
    }

    @include bp(min-width, 1024px) {
      width: 800px;
    }

    button {
      color: $white;
    }

    img {
      display: block;
      max-height: 70px;
      margin-left: auto;
      margin-right: auto;
    }

    .header--highlighted {
        background-color: #456ea8;
        color: white;
        padding: 5px;
        text-align: center;
        border-radius: 5px;
    }

    &__controls {
      &__header {
        margin-bottom: 20px;
      }
    }

    &__survey {
      &__content {
        max-height: 500px;
        overflow-y: auto;
        padding: 20px;
        border: solid 1px rgba($black, .3);
        border-radius: 5px;
      }
      &__actions {
        display: flex;
        margin-top: 30px;
      }
    }
  }

  .select-margin {
    margin-bottom: 75px;
  }

</style>